import { useCallback } from "react";
import { useFilteredBrandsByExistBrandList } from 'store/features/directories';
import { useFavouriteBrands } from 'entities/brands';

import { MAX_RESULT_SEARCH_ITEMS } from '../constants';
import { EMPTY_ARRAY } from 'common/constants';

const MIN_SEARCH_LENGT = 1;

export const useLoadFavouriteBrands = () => {
  const favouriteBrands = useFavouriteBrands() || EMPTY_ARRAY;
  const filteredBrandsByExistBrandList = useFilteredBrandsByExistBrandList(favouriteBrands);

  const loadFavouriteBrands = useCallback(async (brandName: string) => {
    const trimedBrandName = brandName.trim();
    if (trimedBrandName.length >= MIN_SEARCH_LENGT) {
      return filteredBrandsByExistBrandList
        .filter(({ value }) => (
          `${value.title}`.toLowerCase().includes(trimedBrandName.toLowerCase())
        ))
        .slice(0, MAX_RESULT_SEARCH_ITEMS);
    }

    return filteredBrandsByExistBrandList;
  }, [
    filteredBrandsByExistBrandList
  ]);

  return loadFavouriteBrands;
};
